/* À utiliser pour des formulaires contenant un data-iterator et des champs simples (texte, memo, catalogue, etc...) */
export default {
  data() {
    return {
      valid: false,
      valids: [],
    }
  },
  computed: {
    isValid() {
      return this.valid && this.valids.every(x => x)
    }
  },
  mounted() {
    this.$emit("validation-changed", this.isValid)
  },
  watch: {
    valid() {
      this.$emit("validation-changed", this.isValid)
    },
    valids() {
      this.$emit("validation-changed", this.isValid)
    }
  }
}
